import { PaymentCardType } from '@mews/enums';
import PaymentMethod from './PaymentMethod';
import { CardNumberEventData, CardNumberRawEventData } from './types';

const typeMap = {
    [PaymentMethod.Visa]: PaymentCardType.Visa,
    [PaymentMethod.MasterCard]: PaymentCardType.MasterCard,
    [PaymentMethod.Amex]: PaymentCardType.Amex,
    [PaymentMethod.DinersClub]: PaymentCardType.DinersClub,
    [PaymentMethod.JCB]: PaymentCardType.Jcb,
    [PaymentMethod.UnionPay]: PaymentCardType.UnionPay,
    [PaymentMethod.Discover]: PaymentCardType.Discover,
    // We don't use Elo payment card type so it's mapped to a constant value
    [PaymentMethod.ELO]: 'Elo',
};

export default (data: CardNumberRawEventData): CardNumberEventData => {
    const { paymentMethod, ...other } = data;
    const type = typeMap[paymentMethod];

    return { ...other, type };
};
